//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as apis from "@/api";
import { conversion } from "@/tool";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      RebateRate: 0,
      spendAmount: 0,
      rebateAmount: 0,
      claimed: false,
      canClaim: false,
      claiming: false,
      counterTime: {
        timeId: 0, //计时器id
        totalSeconds: 0,
        day: "00",
        hour: "00",
        min: "00",
        sec: "00",
      },
    };
  },
  computed: {
    ...mapState(["user"]),
    claimButtonText() {
      if (this.claiming) return "领取中...";
      if (this.claimed) return "已领取";
      if (this.canClaim) return "立即领取";
      if (this.rebateAmount <= 0) return "暂无可领取";
      return "未到领取时间";
    },
    list() {
      let arr = [];
      if (this.activetyList && this.activetyList.length > 0) {
        arr = this.activetyList;
      }
      return arr;
    },
  },
  filters: {
    conversion,
  },
  watch: {},
  created() {
    this.getRebateDetail();
    this.sumTime(this.counterTime.totalSeconds);

    this.counterTime.timeId = setInterval(() => {
      let time = --this.counterTime.totalSeconds;

      if (time <= 0) {
        //clearInterval(this.counterTime.timeId);
        this.$store.commit("setInfo");
        this.getRebateDetail();
      } else {
        this.sumTime(time);
      }
    }, 1000);
  },
  mounted() { },
  methods: {
    ...mapMutations(["setInfo"]),
    loginbtnClick() {
      this.$store.commit("setloginModal", true);
    },
    sumTime(time) {
      const day = Math.floor(time / (60 * 60 * 24));
      const hour = Math.floor((time / (60 * 60)) % 24);
      const min = Math.floor((time / 60) % 60);
      const sec = Math.floor(time % 60);

      this.counterTime.day = `0${day}`.slice(-2);
      this.counterTime.hour = `0${hour}`.slice(-2);
      this.counterTime.min = `0${min}`.slice(-2);
      this.counterTime.sec = `0${sec}`.slice(-2);

      //console.log(this.counterTime);
    },
    async getRebateDetail() {
      const res = await apis.RebateDetail();
      const data = res.data.data;
      this.counterTime.totalSeconds = data.totalSeconds;
      this.RebateRate = data.rate * 100;
      this.spendAmount = data.spendAmount;
      this.rebateAmount = data.rebateAmount;
      this.claimed = data.claimed;
      this.canClaim = data.canClaim;
      this.sumTime(this.counterTime.totalSeconds);
    },
    async claimRebate() {
      if (!this.user.nickname) {
        this.loginbtnClick();
        return;
      }
      if (this.claiming || !this.canClaim) return;

      this.claiming = true;
      try {
        const res = await apis.ClaimRebate();
        if (!res.data.success) {
          this.$toast.error(res.data.msg || "领取失败");
          return;
        }

        this.$toast.success(res.data.msg || "领取成功");
        await this.getRebateDetail();
        this.setInfo();
      } catch (error) {
        const message = error.response && error.response.data
          ? error.response.data.msg
          : "领取失败，请稍后重试";
        this.$toast.error(message);
      } finally {
        this.claiming = false;
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.counterTime.timeId);
  },
};
